import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleSigninButton = _resolveComponent("GoogleSigninButton")!
  const _component_LinkedInSigninButton = _resolveComponent("LinkedInSigninButton")!
  const _component_FacebookSigninButton = _resolveComponent("FacebookSigninButton")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['SocialIncentiveButtons', { 'Row': _ctx.direction === 'row' }])
  }, [
    _createVNode(_component_GoogleSigninButton, { template: _ctx.googleTemplate }, null, 8 /* PROPS */, ["template"]),
    _createVNode(_component_LinkedInSigninButton, { template: _ctx.template }, null, 8 /* PROPS */, ["template"]),
    _createVNode(_component_FacebookSigninButton, { template: _ctx.template }, null, 8 /* PROPS */, ["template"])
  ], 2 /* CLASS */))
}